import { createSelector } from "reselect";

//Configuration
import { evaluationTypesConfiguration } from "src/constants/filters_configurations/alerts";

export const evaluationTypeFilterConfigSelector = createSelector(
  () => evaluationTypesConfiguration
);
